import { IServiceCharge } from "src/components/projects/project/statements/advanced/interfaces";
import { round } from "src/global";

export function sumServiceCharges(serviceCharges: IServiceCharge[]): number {
  let totalAmountDue = 0.0;
  serviceCharges.forEach(serviceCharge => {
    const charge = round(serviceCharge.totalCharge, 2);
    totalAmountDue += charge;
  });
  return totalAmountDue;
}

export function sumTaxesAndFees(taxesAndFees: IServiceCharge[]): number {
  let totalAmountDue = 0.0;
  taxesAndFees.forEach(serviceCharge => {
    const charge = round(serviceCharge.totalCharge, 2);
    totalAmountDue += charge;
  });
  return totalAmountDue;
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/advanced/AdvancedStatementFunctions.tsx